import { render, staticRenderFns } from "./tableItem.vue?vue&type=template&id=01b0683c&scoped=true"
import script from "./tableItem.vue?vue&type=script&lang=js"
export * from "./tableItem.vue?vue&type=script&lang=js"
import style0 from "./tableItem.vue?vue&type=style&index=0&id=01b0683c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b0683c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01b0683c')) {
      api.createRecord('01b0683c', component.options)
    } else {
      api.reload('01b0683c', component.options)
    }
    module.hot.accept("./tableItem.vue?vue&type=template&id=01b0683c&scoped=true", function () {
      api.rerender('01b0683c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/publish/components/tableItem.vue"
export default component.exports